import { Link, useLocation} from "react-router-dom";

import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import backgroundImg from "./../assets/nightsky/24.jpg";
import Typed from 'typed.js';
import "./../App.css";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {getRecognitions, getOfficeInfo} from './updatables';

import { MotionIcon } from 'motion-icons-react';
import { ItemWrapper } from "./Sidebar/SidebarStyles";
import { ThemeContext } from "./../ThemeContext";

import { supabase } from "./../supabaseClient";

const AboutMe = ({page}) => {

    const el = React.useRef(null);
    const el2 = React.useRef(null);

    const cursorRef = useRef(null);
    const [cursorLine, setCursorLine] = useState("intro");
    const [isTyping, setIsTyping] = useState(false);
    const lastActivityRef = useRef(Date.now());
    const typingTimeoutRef = useRef(null);

    const [isHovered, setIsHovered] = useState(false);

    const location = useLocation();

    const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    const { mathMode } = useContext(ThemeContext);

    const cv = supabase.storage
      .from("pdfs")
      .getPublicUrl("ori-friesen-cv.pdf");

    console.log(cv);

    function signalTyping() {
    lastActivityRef.current = Date.now();
    setIsTyping(true);
    }

    const [showMobileWarning, setShowMobileWarning] = React.useState(false);

    React.useEffect(() => {
    if (page !== "about me" || !isSmallScreen) return;

    const hasSeenWarning = sessionStorage.getItem("mobileWarningShown");

    if (!hasSeenWarning) {
        setShowMobileWarning(true);
        sessionStorage.setItem("mobileWarningShown", "true");
    }

    }, [page, isSmallScreen]);

    React.useEffect(() => {
    if (!el.current || !el2.current) return;

    let subtitle;

    const intro = new Typed(el.current, {
        strings: [`Hello.^2500`, `Hello, I'm <span style="color:#F087D5">Ori Friesen</span>.^2000`],
        typeSpeed: 75,
        showCursor: false,

        onBegin: () => setCursorLine("intro"),

        onComplete: () => {
        setCursorLine("subtitle");

        setTimeout(() => {
            if (!el2.current) return;

            subtitle = new Typed(el2.current, {
            strings: [
                "I'm a mathematician.",
                "I'm a cartographer.",
                "I'm a web developer.",
                "I'm a night sky photographer.",
                "^2500"
            ],
            typeSpeed: 75,
            backSpeed: 40,
            backDelay: 2500,
            loop: true,
            showCursor: false,
            });
        }, 50);
        }
    });

    return () => {
        intro.destroy();
        if (subtitle) subtitle.destroy();
    };
    }, [location.pathname]);

    const [office, setOffice] = React.useState([]);
    const [recognitions, setRecognitions] = React.useState([]);
    
    React.useEffect(() => {
        async function loadRecognitions() {
            const data = await getRecognitions();
            setRecognitions(data);
        }

        loadRecognitions();
    }, []);

    React.useEffect(() => {
            async function loadOffice() {
                const data = await getOfficeInfo();
                console.log("office:", data);
                setOffice(data);
            }
    
            loadOffice();
        }, []);

    return <div>
      <div style={{backgroundImage: `url(${backgroundImg})`, height: "100vh", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between"}}>
        <div style={{display: "flex", width: "100vw", height: "100vh", paddingLeft: "32px", paddingBottom: "32px", alignItems: "flex-start", justifyContent: "flex-end", flexDirection: "column",}}>
          <div className="terminal-line" style={{color: "#eaeced", fontFamily: "mainFont", fontSize: isSmallScreen ? "14px" : "42px"}}>
            <span ref={el} style={{fontFamily: "mainFont"}}></span>
            {cursorLine === "intro" && (
              <span className={`cursor ${isTyping ? "solid" : "blink"}`}>|</span>
            )}
          </div>

          <div className="terminal-line" style={{fontSize: isSmallScreen ? "10px" : "24px", color: "#eaeced", fontFamily: "mainFont", paddingLeft: "2px"}}>
            <span ref={el2} style={{fontFamily: "mainFont"}}></span>
            {cursorLine === "subtitle" && (
              <span className={`cursor ${isTyping ? "solid" : "blink"}`}>|</span>
            )}
          </div>

          <div style={{position: "absolute", top: isSmallScreen ? "calc(100vh - 36px)" : "calc(100vh - 60px)", left: "0", paddingRight: "36px", paddingLeft: isSmallScreen ? "8px" : "0px", textAlign: isSmallScreen ?"left" : "right", width: isSmallScreen ? "calc(100% - 3.5rem)" : "calc(100% - 12%)", fontSize: isSmallScreen ? "10px" : "16px"}}>
            <span style={{ position: "relative", top: "4px", paddingRight: "8px" }}>
              <MotionIcon
                key="arrow-down"
                name="ArrowDown"
                animation="bounce"
                size={20}
                duration={4000}
                color="#7c7788"
              />
            </span>
            scroll down for more
          </div>
        </div>
      </div>
      <div style={{width: isSmallScreen ? "calc(100% - 5rem)" : "calc(100% - 12%)"}}>
        <div id="page" style={{marginLeft: isSmallScreen ? "-8%" : "0px", fontSize: isSmallScreen ? "30px" : "40px"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">
          <Link to="/">
          </Link>
          \{page}
        </div>
        
        <div className="tree" style={{marginLeft: isSmallScreen ? "4%" : "24px"}}>
          <ul>
            <li>
              <a>
                <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">\who am I?</h1>
                <div class="uk-grid" style={{paddingTop: "16px", paddingRight: "4%"}}>
                  <div class="uk-width-1-1@s uk-width-3-4@m">
                    <p style={{textAlign: "justify", paddingRight: "4%", fontSize: isSmallScreen ? "12px" : "16px"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">As you can guess from this site's URL, my name is Ori Friesen. I am currently a second-year Theoretical Mathematics PhD student at <a href="https://math.osu.edu/" target="_blank" rel="noopener noreferrer" style={{ color: "#d866a3", padding:0, margin:0, cursor:"pointer" }}>the Ohio State University</a>. Getting my Bachelors of Arts in Mathematics with minors in Computer Science and Geospatial Science from Macalester College, I have a wide array of interests outside of math. Here, you will find both my mathematical interests, experience, and accomplishments, along with other projects and hobbies I have taken on dating back to high school.
                    <br/><br/>
                    Below are some accomplishments that I am proud of:
                    </p>

                    <TableContainer style={{paddingRight: "4%"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">
                      <Table sx={{ width: "100%", tableLayout: "fixed",
                      "& .MuiTableCell-head": {
                          fontFamily: "mainFont",
                          fontWeight: 700,
                          color: "#7c7788",
                          fontSize: isSmallScreen ? "8px" : "14px"
                          },
                          "& .MuiTableCell-body": {
                          fontFamily: "mainFont",
                          color: "#7c7788",
                          fontSize: isSmallScreen ? "8px" : "14px"
                          },
                      }} size="small">
                          <TableHead>
                          <TableRow>
                              <TableCell sx={{width: "18%"}}>Recognition</TableCell>
                              <TableCell sx={{width: "35%"}}>Description</TableCell>
                              <TableCell sx={{width: "8%"}}>Year</TableCell>
                              <TableCell sx={{width: "10%"}}>Affiliation</TableCell>
                          </TableRow>
                          </TableHead>
                          <TableBody>
                          {recognitions.map((row) => (
                              <TableRow
                              key={row.title}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 },
                              transition: "background-color 0.2s ease",
                              "&:hover": {
                              backgroundColor: "#F0B6D520",
                              }, }}
                              >
                              <TableCell component="th" scope="row" style={{fontFamily: "mainFontItalic"}}>
                                  {row.title}
                              </TableCell>
                              <TableCell align="left" style={{fontFamily: "mainFontPar", textAlign: "justify"}}>{row.description}</TableCell>
                              <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.year}</TableCell>
                              <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.institution}</TableCell>
                              </TableRow>
                          ))}
                          </TableBody>
                      </Table>
                  </TableContainer>

                    <p style={{textAlign: "justify", paddingRight: "4%", fontSize: isSmallScreen ? "12px" : "16px"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">
                      If you want a more condensed summary of my mathematical journey, click the button below to view my CV!
                    </p>
                    <button 
                      className="cv-button"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      style={{marginLeft: "12px", marginBottom: "24px"}}
                      onClick={() => {
                        const { data } = supabase.storage
                          .from("pdfs")
                          .getPublicUrl("ori-friesen-cv.pdf");

                        window.open(data.publicUrl, "_blank", "noopener,noreferrer");
                      }}
                      uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false"
                    > 
                      <div class="cv-wrapper">
                        <MotionIcon
                          key={isHovered ? "hover" : "idle"}
                          name="LucideFileText"
                          animation="bounce"
                          trigger={isHovered ? "always" : "click"}
                          size={20}
                          color={isHovered ? "#F0B6D5" : "#7c7788"}
                        />
                        <div style={{paddingLeft: "12px"}} color={isHovered ? "#F0B6D5" : "#7c7788"}>Open CV</div>
                      </div>
                    </button>
                  </div>
                  <div class="uk-width-1-1@s uk-width-1-4@m" uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">
                    <img src={require("./../assets/ori_image.jpg")} alt="me!" style={{width: "100%", paddingRight: "4%", borderRadius: "8px"}}></img>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a style={{width: "100%"}}>
                <h1 uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">\where am I?</h1>
                <div class="uk-grid" style={{paddingTop: "20px", paddingRight: "4%", paddingBottom:"20px"}}>
                  <div class="uk-width-1-1@s uk-width-1-3@m">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1442.3826111752123!2d-83.01499144021946!3d40.001694383811945!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388f2bf66d26d7%3A0x7e5e2cc5783d455c!2sMathematics%20Tower!5e0!3m2!1sen!2sus!4v1785118572955!5m2!1sen!2sus" width="100%" height="300" allowFullScreen="" loading="lazy" referrerPolicy="strict-origin-when-cross-origin" style={{borderRadius: "8px", marginLeft: "12px"}} uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false"></iframe>
                  </div>
                  <div class="uk-width-1-1@s uk-width-2-3@m" uk-scrollspy="cls: uk-animation-slide-bottom; repeat: false">
                    <p style={{textAlign: "justify", paddingRight: "4%", paddingTop: "8px", fontSize: isSmallScreen ? "12px" : "16px"}}>
                      Looking for me? Stop by my office to chat!
                    </p>
                    <div style={{alignItems: "center", paddingBottom: "8px", fontSize: isSmallScreen ? "12px" : "16px"}}>
                      <span style={{ position: "relative", top: "3px", paddingRight: "8px", paddingLeft: "32px" }}>
                        <MotionIcon
                          name="MapPin"
                          animation="flip"
                          trigger="hover"
                          size={20}
                          duration={4000}
                          color="#F0B6D5"
                        />
                      </span>
                      <span style={{fontFamily: "mainFontItalic"}}>Office Location:</span> {office[0]?.room}
                    </div>

                    <span style={{ position: "relative", top: "3px", paddingRight: "8px", paddingLeft: "32px", fontSize: isSmallScreen ? "12px" : "16px" }}>
                      <MotionIcon
                        name="CalendarDays"
                        animation="flip"
                        trigger="hover"
                        size={20}
                        duration={4000}
                        color="#F0B6D5"
                      />
                    </span>
                    <span style={{fontFamily: "mainFontItalic", fontSize: isSmallScreen ? "12px" : "16px"}}>Office Hours (Fall 2026):</span> <span style={{fontSize: isSmallScreen ? "12px" : "16px"}}>{office[0]?.hours}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {showMobileWarning && (
        <div className="mobile-warning-overlay">
          <div className="mobile-warning-dialog">
            <h2>Warning</h2>
            <p>This page is not optimized for mobile. While most features will work, for optimal viewing, use desktop.</p>
            <button class="button" onClick={() => setShowMobileWarning(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>};

export default AboutMe;